import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../../../../service/data.service';

@Component({
    selector: 'app-income-tax-details-en-v2',
    templateUrl: './income-tax-details-en-v2.component.html',
    styleUrls: ['./income-tax-details-en-v2.component.css'],
    standalone: false
})
export class IncomeTaxDetailsEnV2Component implements OnInit {

  constructor(private dataSource: DataService) { }

  @Input() returnData: any;
  @Input() printActive: boolean;
  @Input() inputEnable: boolean;
  isCsrDonation: boolean = false;

  assessmentYearStart: string;

  ngOnInit(): void {
    this.dataSource.data$.subscribe(() => {
      const currentAssessmentYear = this.returnData?.submissionInfo?.assessmentYear;
      this.assessmentYearStart = currentAssessmentYear?.split('-')[0];
      this.isCsrDonation = this.returnData?.headSummery?.csrSummary?.csrList?.length;
    });
  }

  addIncentive(amount: number | string | null | undefined): number {
    const base = Number(amount ?? 0);
    const incentive = Number(this.returnData?.taxPaymentData?.tc_S_Incentive || 0);
    return (isNaN(base) ? 0 : base) + (isNaN(incentive) ? 0 : incentive);
  }

  reduceIncentive(amount: number | string | null | undefined): number {
    const base = Number(amount ?? 0);
    const incentive = Number(this.returnData?.taxPaymentData?.tc_S_Incentive || 0);
    return (isNaN(base) ? 0 : base) - (isNaN(incentive) ? 0 : incentive);
  }
}
